import { ReactComponent as CalendarIcon } from '@/assets/svg/Calendar.svg';
import React, { ForwardedRef } from 'react';

interface DateInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
  error?: string;
}

const DateInput: React.FC<DateInputProps> = ({
  label,
  value,
  onChange,
  required,
  inputRef,
  error,
}) => {
  return (
    <div className='flex w-full flex-col gap-[8px]'>
      <label className='w-fit text-[20px] font-medium leading-[26px]'>
        {label} {required && <span className='text-red500'>*</span>}
      </label>
      <div className='relative'>
        <input
          ref={inputRef}
          type='date'
          className={`h-[72px] w-full rounded-2xl border border-solid border-[#E1E1E1] px-6 pr-12 text-xl font-normal leading-[26px] outline-none ${
            error ? 'border-red-500' : ''
          }`}
          value={value}
          onChange={onChange}
          required={required}
        />
        <span
          className='absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer'
          onClick={() => {
            if (inputRef?.current) {
              if (typeof inputRef.current.showPicker === 'function') {
                inputRef.current.showPicker();
              } else {
                inputRef.current.focus();
              }
            }
          }}
        >
          <CalendarIcon />
        </span>
      </div>
      {error && <span className='text-red-500 mt-1 text-sm'>{error}</span>}
    </div>
  );
};

export default DateInput;
